// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__pIfYD","site_layout_content":"style_site_layout_content__6ahoR"};